export enum ModalViewport {
  XSmall = 'xsmall',
  Small= 'small',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'xlarge',
  Screen = 'screen'
}
